import { render, staticRenderFns } from "./AutoEducationalBackgrounds.vue?vue&type=template&id=19c21d58"
import script from "./AutoEducationalBackgrounds.vue?vue&type=script&lang=js"
export * from "./AutoEducationalBackgrounds.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports